import { useInfiniteQuery } from '@tanstack/react-query'
import { PulsePaginatedFilters } from 'api/pulse'
import { getPayRateMarketByLocationKey } from './keys'
import {
  PayRateMarketByLocation,
  getPayRateMarketByLocation,
} from 'api/pulse/payRateMarketByLocation'
import { PULSE_QUERY_OPTIONS } from './constants'

export function usePayRateMarketByLocation(query: PulsePaginatedFilters) {
  return useInfiniteQuery<PayRateMarketByLocation>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getPayRateMarketByLocationKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getPayRateMarketByLocation(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
    refetchOnWindowFocus: false,
  })
}
